<template>
  <div>
    <!-- <v-breadcrumbs :items="items" class="breadcrumb">

    </v-breadcrumbs> -->
    <v-col cols="12" sm="12">
      <v-card class="box">
        <v-col cols="12" sm="12">
          <v-toolbar class="toolbar" flat dense>
            <v-toolbar-title>
              <strong>
                Suggesions
              </strong>
            </v-toolbar-title>
          </v-toolbar>
          <v-row align="center" justify="center">
            <v-col sm="3" md="3" v-for="link in link_data" :key="link.link">
              <v-card :elevation="5" class="card" fill-height style="margin: 8px; height: 90%;"
                :class="[currentPage.includes(link.link) ? activeClass : 'inactive']">
                <router-link :to="{ name: link.link }" class="link">
                  <v-list-item class="link-item">
                    <v-list-item-icon>
                      <v-icon class="linkname">{{ link.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="linkname">{{ link.name }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </router-link>
              </v-card>
            </v-col>

          </v-row>
        </v-col>
      </v-card>
    </v-col>
    <router-view />
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    link_data: [
      {
        link: "resolve-feedback",
        icon: "mdi-read",
        name: "Received Suggesions",
      },
      {
        link: "read-not-resolve-feedback",
        icon: "mdi-content-save",
        name: "Read And Not Resolved Suggesions",
      },
      {
        link: "all-feedback",
        icon: "mdi-content-save-all",
        name: "All Suggesions",
      },
      {
        link: "feedback-stats",
        icon: "mdi-chart-line-stacked",
        name: "Suggesions Stats",
      },
    ],
    activeClass: 'active',
    items: [
      { text: "Home", disabled: false, href: "/home-updated" },
      { text: "Feedback", disabled: true, href: "" },
    ],
  }),
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  mounted() {
    sessionStorage.setItem("para_role_type","Feedback status")
    this.$router.push({ name: 'resolve-feedback' })
  },
};
</script>
<style scoped>
.link {
  text-decoration: none;
}

.linkname {
  color: 0F2027;
}
.active .linkname {
  color: #FFFFFF !important;
}
.card {
  border-radius: 50px !important;
}

.card:hover {
  font-weight: bold !important;
  text-align: center;
  box-shadow: 20px 20px 20px grey !important;
  -webkit-transition: box-shadow 0.3s ease-in !important;
}

.active {
  /* background: orange; */
  background: #bdc3c7;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base));
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, var(--v-brand-base), var(--v-brandLight-base));
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  /* background-color: transparent; */
  box-shadow: 20px 20px 20px gray;
  color: #FFFFFF !important;
  font-weight: bold !important;
}

.inactive {
  /* background: #ffd699; */
  background-color: transparent;
  color: #0F2027;
  border: 1px solid #0F2027 !important;
}
 .breadcrumb {

   padding: 10px;

   margin-left: 80px;
   margin-top: -50px;
   font-size: medium;
   font-weight: bold;
 }
</style>